// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1F-vB","right":"styles_right__11cYE"};